import { NgModule } from "@angular/core";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { JiraIssueIconComponent } from "./components/jira-icon/jira-icon.component";

@NgModule({
  imports: [UiTooltipModule],
  declarations: [JiraIssueIconComponent],
  exports: [JiraIssueIconComponent],
})
export class TasksModule {}
